export default __webpack_public_path__ + "static/media/forgot-password-dark.31d6cfe0.svg";